import { useMutation } from "react-query";
import { updateDataConnection } from "../../../../../actions/Utilities/DataConnection";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  editStateDataConnection,
  dataConnectionReFetching,
} from "../atoms/atoms";
import { IDataCon } from "../types";
import { toast } from "components/toastNotification";

const useEditDataConnection = () => {
  const setActionEditState = useSetRecoilState(editStateDataConnection);
  const [isReFetching, setIsReFetching] = useRecoilState(
    dataConnectionReFetching
  );

  const { mutate } = useMutation(
    (newData: IDataCon) => updateDataConnection(newData),
    {
      onSuccess: (res) => {

        if (typeof res == "object") {
          toast.fire(
            "Updating Data Connection failed",
            `${res.Message}`,
            "error"
          );
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Data Connection Updated Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Data Connection Updated Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Updating Data Connection failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Updating Data Connection failed ",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            case res.includes("Action object"):
              toast.fire(
                "Updating Data Connection failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire(
                "Updating Data Connection failed",
                `${res}`,
                "error"
              );
          }
        }
        setActionEditState(false);
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error: any) => {
        toast.fire(
          "Update Data Connection failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );
  return mutate;
};

export default useEditDataConnection;
